import $ from 'jquery';

// Singletone client to be used across the app; it will cache `clientId` value
export const client = analyticsClient();

/**
 * @description runs a callback function when Google Analytics object is defined
 * @param callback {Function} function to be executed when `ga` is available on `window`.
 *                            Receives the tracker as parameter.
 */
export function runWhenGoogleAnalyticsIsLoaded(callback) {
    if (window.ga && window.ga.create) {
        callback(window.ga);
    } else {
        setTimeout(() => {
            runWhenGoogleAnalyticsIsLoaded(callback);
        }, 500);
    }
}

/**
 * @description
 * @returns {Object} with `getClientId` function
 */
export function analyticsClient() {
    let clientId = null;

    return {
        /**
         * @description get clientId from Google Analytics tracker.
         * @returns {Promise} that gives the clientId value
         */
        getClientId() {
            /* eslint-disable */
            const promise = $.Deferred();
            /* eslint-enable */

            if (clientId !== null) {
                promise.resolve(clientId);
            }

            runWhenGoogleAnalyticsIsLoaded((_ga) => {
                _ga(() => {
                    const [firstTracker] = _ga.getAll();

                    clientId = firstTracker.get('clientId');

                    promise.resolve(clientId);
                });
            });

            return promise;
        }
    };
}




/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/common/client.js
 **/